import type { userManagementStats } from "@/features/userManagement/types.props";
import axiosInstance from "@/lib/axios";

export const getUserManagementStats =
    async (): Promise<userManagementStats> => {
        const { data } =
            await axiosInstance.get<userManagementStats>(`/users/stats/`);
        return data;
    };
